const ytb = {
  chanelId: "UCUD8PAN1661urrA1xzuKLmg",

  //DO NOT MODIFY OR TOUCH
  url: "https://api.rss2json.com/v1/api.json?rss_url=https://www.youtube.com/feeds/videos.xml?channel_id=",
};

export default ytb;
